module.exports = __webpack_public_path__ + "img/balao_balao_2.81e54194.png";